import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

import {updateOffscreenPanelVisibility} from '../utils/a11y';

const selectors = {
  slider: '[data-slider]',
  slide: '[data-slide]',
};

export default register('terms-banner', {
  onLoad() {
    this.isAnimated = false;

    const termsBannerSlider = this.container.querySelector(selectors.slider);
    if (!termsBannerSlider) return;
    const termsBannerSlides = [...termsBannerSlider.querySelectorAll(selectors.slide)];
    if (termsBannerSlider) {
      this.termsBannerSlider = new Flickity(termsBannerSlider, {
        autoPlay: true,
        freeScroll: false,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'center',
        watchCSS: true,
        wrapAround: true,
        pauseAutoPlayOnHover: true,
        on: {
          ready() {
            updateOffscreenPanelVisibility(termsBannerSlides);
          },
          change() {
            updateOffscreenPanelVisibility(termsBannerSlides);
          },
        },
      });
    }
  },
});
